import { render, staticRenderFns } from "./CoverPreview.vue?vue&type=template&id=59c31520"
import script from "./CoverPreview.vue?vue&type=script&lang=js"
export * from "./CoverPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports